import React, { useContext, useEffect, useState } from 'react'

//interfaces
import { ITableColumn, ITableContent, ITableRows } from  '@/interfaces/simpleTable';
import { AllUsersSortByType } from  '@/interfaces/orgSettings';
import { SortBy } from  '@/interfaces/toggle';

//helpers
import { Truncate } from  '@/helpers/Text';
import { isExternallyManaged } from  '@/helpers/OrgSettings';

//components
import UserIconAndName from  '@/components/elements/orgSettings/tableCellItems/UserIconAndName';

//context
import { OrgSettingsUserGroupsContext } from '@/context/OrgSettingsUserGroupsContext';



const UseUserGroupsUsersTabs = () => {  
    const {notificationDetails, getUsers, userData, paginationSettings, searchString, setSearchString, setUsersSortToggle, usersSortToggle, isLoading, setIsLoading, userGroupId, groupCanBeModified, removeUserFromGroup, getModalUsers} = useContext(OrgSettingsUserGroupsContext);
    const [tableContent, setTableContent] = useState<ITableContent>();
    const [showSimpleTable, setShowSimpleTable] = useState<boolean>(false);
    const [showAddUsersToGroupModal, setShowAddUsersToGroupModal] = useState<boolean>(false);
    
    const columns: ITableColumn[] = [
        { title: "Username", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.USERNAME, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.USERNAME, SortBy.ASCENDING)}, 
        { title: "First Name", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.FIRST_NAME, SortBy.DESCENDING),  onSortDescendingClick: () => toggleSort(AllUsersSortByType.FIRST_NAME, SortBy.ASCENDING)}, 
        { title: "Last Name", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.LAST_NAME, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.LAST_NAME, SortBy.ASCENDING)}, 
        { title: "Job Role", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.JOB_ROLE, SortBy.DESCENDING),  onSortDescendingClick: () => toggleSort(AllUsersSortByType.JOB_ROLE, SortBy.ASCENDING)}, 
    ];
    const searchInputLabel =  "Filter users with search input";
    const panelTitle = "Include";
    const archivedUserLabel = "Archived Users";
    const noDataMessage = "No users have been added to this group";
    const addUsersToGroupButtonText = "+ Add Users to Group";
    const bulkAddUsersButtonText = "+ Bulk Add Users"; 
    const addUsersToGroupButtonLabel = "Add a user to the group";
    const bulkAddUsersButtonLabel = "Add Multiple Users to this group"; 
    const createNewUserButtonText = "+ Create New User";
    const createNewUserButtonLabel = "Create a new user to the organisation";

    useEffect(()=> {
        setIsLoading(true);
        getUsers();
    }, [searchString, usersSortToggle, userGroupId]);

    useEffect(()=> {
        getModalUsers('new');
    }, [showAddUsersToGroupModal]);

    useEffect(() => {
        if (userData === undefined) {
            setIsLoading(true);
            setTableContent({rows: [], columns: columns});
            setShowSimpleTable(true);
            return;
        }

        let rows: ITableRows[] = [];
        userData?.forEach((user) => {
            const row: ITableRows = {
                content: [
                    <UserIconAndName 
                        profilePicture={user.profilePicUrl} 
                        userId={user.id} 
                        username={user?.userName ?? ""} 
                        truncate={18}
                        isManagedUser={isExternallyManaged(user.userManagementType)}
                        externalLoginIcon={user.provider?.iconUrl}
                    />,
                    <span className='bolder-text'>{Truncate(user.firstName ?? "", 12)}</span>, 
                    <span className='bolder-text'>{Truncate(user.lastName ?? "", 12)}</span>, 
                    Truncate(user.jobRole ?? "", 12), 
                ], 
                isHighlightedRow:isExternallyManaged(user.userManagementType),
                controls: groupCanBeModified ? [{content:"Remove From Group", onClick:() => onRemoveUserFromGroupClick(user.id)}] : []
            };
            rows.push(row);
        });
 
        setTableContent({rows: rows, columns: columns});
        setIsLoading(false);
        setShowSimpleTable(true);
    }, [userData])

    function toggleSort(sortByType: AllUsersSortByType, sortBy: SortBy) {
        setUsersSortToggle([sortByType, sortBy]);
    }

    function onRemoveUserFromGroupClick(userId:any) {
        removeUserFromGroup(userId, userGroupId);
    }

    function onBulkAddUsersClick() {
        window.location.replace(`/admin/BulkAddUser?groupId=${userGroupId}`);
    }

    function onShowAddUsersToGroupModal() {
        setShowAddUsersToGroupModal(true);
    }

    function onHideAddUsersToGroupModal() {
        setShowAddUsersToGroupModal(false);
        getUsers();
    }

    function onCreateNewUserClick() {
        window.location.replace(`/admin/OrganizationUser/Create`);
    }

    function getNewPage(page: number) {
        getUsers(page);
    }

    return{addUsersToGroupButtonText, bulkAddUsersButtonText, addUsersToGroupButtonLabel, bulkAddUsersButtonLabel, onBulkAddUsersClick, searchInputLabel, panelTitle, archivedUserLabel, noDataMessage, notificationDetails, paginationSettings, setSearchString, searchString, tableContent, showSimpleTable, getNewPage, isLoading, showAddUsersToGroupModal, onHideAddUsersToGroupModal, onShowAddUsersToGroupModal, groupCanBeModified, createNewUserButtonText, createNewUserButtonLabel, onCreateNewUserClick}
}

export default UseUserGroupsUsersTabs

export type IUseUserGroupsUsersTabs = ReturnType<typeof UseUserGroupsUsersTabs>;